module.exports = __webpack_public_path__ + "static/media/ws1.34a170a0.png";